import { render, staticRenderFns } from "./clazz-info.vue?vue&type=template&id=3f2beba8&scoped=true"
import script from "./clazz-info.vue?vue&type=script&lang=js"
export * from "./clazz-info.vue?vue&type=script&lang=js"
import style0 from "./clazz-info.vue?vue&type=style&index=0&id=3f2beba8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2beba8",
  null
  
)

export default component.exports